import { useRecoilState, useRecoilValue } from 'recoil';
import { compareColumnOpen, isReportState } from 'venn-state';
import React, { useContext } from 'react';
import { AllocationPanelContext } from '../AllocationPanelContext';
import StudioAllocatorSubjectSelector from './StudioAllocatorSubjectSelector';
import { AggregatedGroupBySelector } from './AggregatedGroupBySelector';
import { StudioAllocatorSubjectSection } from './components';
import { ClosePanelButton } from '../../side-panel-settings/ClosePanelButton';

interface StudioAllocatorSubjectProps {
  disabled: boolean;
  isPrivate?: boolean;
  hideCompareLink?: boolean;
  onClose?: () => void;
}

export const StudioAllocatorSubject = ({
  disabled,
  isPrivate = false,
  hideCompareLink = false,
  onClose,
}: StudioAllocatorSubjectProps) => {
  const isReport = useRecoilValue(isReportState);
  const { allocationPanelType } = useContext(AllocationPanelContext);
  const isHistorical = allocationPanelType === 'historical read-only';
  return (
    <StudioAllocatorSubjectSection>
      <div className="flex items-center justify-between gap-[16px]">
        <StudioAllocatorSubjectSelector disabled={disabled} />
        <ClosePanelButton onClose={onClose} />
      </div>
      <AggregatedGroupBySelector />
      {!isHistorical && !isPrivate && !isReport && !hideCompareLink && <CompareLink disabled={disabled} />}
    </StudioAllocatorSubjectSection>
  );
};

const CompareLink = ({ disabled }: { disabled: boolean }) => {
  const [compareOpen, setCompareOpen] = useRecoilState(compareColumnOpen);
  const onLinkClick = () => setCompareOpen(!compareOpen);

  return (
    <div style={{ textAlign: 'right' }}>
      <button
        onClick={onLinkClick}
        disabled={disabled}
        type="button"
        className="text-venn-primary-dark font-bold text-[14px] leading-[24px] mt-2"
      >
        {compareOpen ? 'Hide Compare' : 'Compare Versions'}
      </button>
    </div>
  );
};
